import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

export type ToastType = 'success' | 'error' | 'alert';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly baseConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top',
    panelClass: ['toast-notification']
  };

  constructor(private snackBar: MatSnackBar) {}

  success(message: string, config?: MatSnackBarConfig): void {
    this.open(message, 'success', config);
  }

  error(message: string, config?: MatSnackBarConfig): void {
    this.open(message, 'error', config);
  }

  alert(message: string, config?: MatSnackBarConfig): void {
    this.open(message, 'alert', config);
  }

  private open(message: string, type: ToastType, config?: MatSnackBarConfig): void {
    const mergedConfig: MatSnackBarConfig = {
      ...this.baseConfig,
      ...config,
      panelClass: [
        ...(this.baseConfig.panelClass || []),
        `toast-${type}`,
        ...((config && config.panelClass) || [])
      ]
    };

    this.snackBar.open(message, '✕', mergedConfig);
  }
}
